import React from 'react';
import { Typography, Grid } from '@material-ui/core'
import './main.css';
import waves from '../images/WAVES.png';
import demo from './images/ZL ontop of WD 2 .webm';
import AppearingElement from "../Helper/AppearingElement";

function Slide() {
    return (
        <div className="slide" >
            <img src={waves} alt="" className="slide__waves" />
            <Grid container
                spacing={1}
                direction="row"
                justify="space-around"
                alignItems="flex-start">
                <Grid item xs={12} sm={12} md={5} className="slide-grid-container">
                    <AppearingElement variant="zoom-down">
                        <Typography className="slide__main-text" variant="h3" >Rethink Your Workday Experience!</Typography>
                    </AppearingElement>
                    <AppearingElement variant="zoom-down">
                        <Typography className="slide__sub-text" variant="subtitle1" >Ziplyne enables you and your company to navigate Workday modules to their fullest, without the need to consistently rely on an outside implementation partner or in-house training and support teams.</Typography>
                    </AppearingElement>
                </Grid>
                <Grid item xs={8} sm={8} md={5}>
                    <video src={demo} className="slide__video" autoPlay loop muted />
                </Grid>
            </Grid>
        </div>
    )
}

export default Slide